<template>
  <section class="cx-sec m-happening" ref="container">
    <div class="cx-wrap--page m-wrap--page">
      <div class="cx-div--outer">
        <h2 :aria-label="$t('enf.whatsHappening')" class="cx-t20 m-happening__title"
        >{{$t('enf.whatsHappening')}}</h2>
      </div>
      <div class="cx-div--outer m-happening__articles">
        <div class="cx-row">
          <div class="cx-col-lg-8 m-happening__feed" v-show="cards.length > 0">
            <div class="cx-row">
              <div v-for="(event, idx) in cards" 
                :key="idx"
                class="cx-col-md-6 cx-div">
                <component
                  :is="''"
                  :aria-label="`${event.name}`"
                  v-bind="linkProps(event.link ? event.link : `/events/${event.isWhatson ? 'whatson/' : 'calendar/'}${event.id}`)"
                >
                  <article class="cx-row--flat">
                    <div class="cx-col">
                      <div class="cx-media">
                        <cx-img
                          tag="div"
                          class="cx-media__img--round"
                          :imgSrc="getMediaHost(event.thumbnail, 'MGTO_MEDIA')"
                          :srcSet="'320 767w, 640 900w, 720 1200w'"
                          lazyLoad
                          square
                        ></cx-img>
                      </div>
                    </div>
                    <header class="cx-col">
                      <div v-if="event.date" 
                        class="cx-t01 cx-list--sm -fade m-happening__date">
                        <span class="cx-link__icon">
                          <i class="fa-fw fal fa-calendar"></i>
                        </span>
                        <span :aria-label="$t('common.date')">{{event.date}}</span>
                      </div>
                      <h3 class="cx-t20" dir="ltr">
                        {{event.name}}
                      </h3>
                    </header>
                  </article>
                </component>
              </div>
            </div>
          </div>

          <div class="cx-col-lg-8 m-happening__feed" v-if="cards.length == 0">
            <div class="cx-row">
              <div v-for="idx in 6" 
                :key="'ph_' + idx"
                class="cx-col-md-6 cx-div">
                <a>
                  <article class="cx-row--flat">
                      <div class="cx-col">
                        <div class="cx-media">
                          <div class="cx-media__img--round"></div>
                        </div>
                      </div>
                      <div class="cx-col" style="width: 100%">
                        <content-placeholders
                          :animated="false"
                          rounded >
                          <content-placeholders-heading/>
                        </content-placeholders>
                      </div>
                  </article>
                </a>  
              </div>
            </div>
          </div>

          <div class="cx-col-lg-4 m-happening__slide" v-show="banners.length > 0">
            <div class="cx-div">
              <cx-slider-v2 draggable arrowNagv cycling loop @change="handleSlideChange">
                <cx-slider-item v-for="(banner, idx) in bannerGallery" :key="banner.path + idx">
                <component
                  slot-scope="slotProps"
                  tabindex="-1"
                  @focus="slotProps.focusHandler"
                  @blur="slotProps.blurHandler"
                  :is="''"
                  :aria-label="banner.name"
                  v-bind="linkProps(banner.link || banner.to || null)">
                  <div class="cx-media--cover">
                    <cx-img
                      tag='div'
                      :imgSrc="`${banner.path}`"
                      :key="banner.path"
                      lazyLoad
                      class="cx-media__img m-hero__slide" 
                      :faceFocus="banner.isWhatson"
                    ></cx-img>
                  </div>
                  </component>
                </cx-slider-item>
              </cx-slider-v2>
            </div>
            <div class="cx-div">
              <component
                :is="''"
                role="button"
                v-bind="linkProps(activeBanner.link ? activeBanner.link : `/events/${activeBanner.isWhatson ? 'whatson/' : ''}/${activeBanner.id}`)"
                v-if="activeBanner.name"
              >
                <div class="cx-slider__caption">
                  <div class="cx-t01 -fade" v-if="activeBanner.date">
                    <span class="cx-link__icon">
                      <i class="fa-fw fal fa-calendar"></i>
                    </span>
                    <span>{{activeBanner.date}}</span>
                  </div>
                  <h3 class="cx-t20" dir="ltr">{{activeBanner.name}}</h3>
                </div>
              </component>
            </div>
          </div>

          <div class="cx-col-lg-4 m-happening__slide" v-if="banners.length == 0">
            <div class='cx-div'>
              <div class="cx-media--cover" style="border-radius: 5px">
                <div class="cx-media__img m-hero__slide"></div>
              </div>
            </div>
            
            <content-placeholders :animated="false" :rounded="true">
              <content-placeholders-heading/>
            </content-placeholders>
          </div>
        </div>
      </div>

      <section class="cx-div--outer m-happening__actions">
        <h3 class="cx-t01 -fade m-subtitle"
        >{{$t('enf.seeMoreEnf')}}</h3>
        <div class="cx-list cx-t00">
          <span class="cx-list__item">
            <router-link-localed to="/events/whatson" class="cx-link">
              <span class="cx-link__icon">
                <i class="fa-fw fa-2x fal fa-bullhorn"></i>
              </span>
              <span class="cx-link__text"
              >{{$t('enf.whatsOn')}}</span>
            </router-link-localed>
          </span>
          <span class="cx-list__item">
            <router-link-localed to="/events/calendar" class="cx-link">
              <span class="cx-link__icon">
                <i class="fa-fw fa-2x fal fa-calendar-star"></i></span>
              <span class="cx-link__text"
              >{{$t('enf.eventCalendar')}}</span>
            </router-link-localed>
            <!-- </a> -->
          </span>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import lazyLoadHelper from "@/mixins/lazyLoadHelper";

export default {
  name: "home-whats-happening",
  mixins: [lazyLoadHelper],
  uit() {
    return [
      ["enf", ["whatsHappening", "whatsOn", "eventCalendar", "seeMoreEnf"]],
      ["common", ["date"]],
    ];
  },
  data() {
    return {
      mount: false,
      activeBanner: {},
    };
  },
  computed: {
    cards() {
      return (
        this.$store.getters["whatshappening/getCards"](this.$i18n.locale) || []
      );
    },
    banners() {
      let banners =
        this.$store.getters["whatshappening/getBanners"](this.$i18n.locale) ||
        [];

      this.activeBanner = banners[0] || {};
      return banners;
    },
    bannerGallery() {
      return this.banners.map((b) => ({
        name: b.name,
        path: this.getMediaHost(b.thumbnail, "MGTO_MEDIA"),
        link: b.link,
        to: `/events/${b.isWhatson ? "whatson/" : ""}${b.id}`,
        isWhatson: b.isWhatson,
      }));
    },
    // activeBanner() {
    //   if (!this.mount) return {};
    //   let idx = this.$refs.slider ? this.$refs.slider.activeSlide -1 : -2;

    // if (idx == -1) {
    //   idx = this.banners.length - 1;
    // } else if (idx == this.banners.length) {
    //   idx = 0;
    // }

    // return (idx > -1 && this.banners[idx])
    //   ? this.banners[idx]
    //   : {};
    // }
  },
  methods: {
    handleSlideChange: function(idx) {
      if (idx == -1) {
        idx = this.banners.length - 1;
      } else if (idx == this.banners.length) {
        idx = 0;
      }

      this.activeBanner =
        idx > -1 && this.banners[idx] ? this.banners[idx] : {};
    },
  },
  mounted() {
    this.mount = true;
    this.lazyLoad(this.$refs.container, () => {
      this.$store.dispatch("whatshappening/FETCH_WHATSHAPPENING", {
        locale: this.$i18n.locale,
      });
    });
  },
};
</script>

<style lang="scss">
.home-whats-happending-ph {
  width: 100% !important;
  // .vue-content-placeholders-heading__content{
  //   display: flex;
  // }
}
.home {
  .m-happening {
    background-color: $color-grey;
  }
}
.m-happening {
  &__title {
    @extend %style-title;
  }
  &__articles {
    @include normalize-link($color-primary);
    margin-bottom: $space-lg !important;

    .m-happening__feed .cx-div > a {
      display: block;
    }
  }
  &__feed {
    @include set-font(0.7);
    @media (max-width: $breakpoint-lg) {
      margin-bottom: $space-base;
    }
    article.cx-row--flat {
      > header.cx-col {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    .m-happening__date {
      font-size: 0.7rem;
    }
  }
  &__slide {
    @include set-font(0.7);
    .cx-slider {
      border-radius: $br-base;
      overflow: hidden;
    }
    .cx-link__icon {
      // font-size: 1.5rem;
    }
    @media (max-width: $breakpoint-lg) {
      display: flex;
      flex-wrap: wrap;
      & > .cx-div {
        margin-bottom: 0;
        &:first-child {
          flex: 4 0 280px;
        }
        &:last-child {
          flex: 1 0 200px;
          padding: $space-base;
          background-color: $color-white;
          border-radius: $br-base;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }
    }
    & > .cx-div {
      &:last-child {
        padding-bottom: 2rem;
        // min-height: 125px;
      }
    }
  }
  &__actions {
    margin-bottom: 0 !important;
    a {
      @extend %style-text-link;
      margin-bottom: 0.25rem;
    }
  }
  .m-hero__cover {
    .m-hero__slide {
      padding-top: 56.25%;
    }
  }
}
</style>
